import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "groupInputs flex" }
const _hoisted_3 = { class: "inputRow" }
const _hoisted_4 = { class: "inputTitle" }
const _hoisted_5 = { class: "inputField flex-grow" }
const _hoisted_6 = { class: "groupInputs flex" }
const _hoisted_7 = { class: "inputRow" }
const _hoisted_8 = { class: "inputTitle" }
const _hoisted_9 = { class: "inputField flex-grow" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "error-msg" }
const _hoisted_12 = { class: "inputRow" }
const _hoisted_13 = { class: "inputTitle" }
const _hoisted_14 = { class: "inputField flex-grow" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "error-msg" }

import {computed, onMounted, ref, toRef} from "vue";
import Text from "@/components/inputs/Text";
import {helpers, required} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import {useGlobalStore} from "@/stores/GlobalStore";
import {useI18n} from "vue-i18n";
import {$t} from "@/utilities/i18n/config";
import {phoneNumberPlaceholder} from "@/AppConfig";


export default /*#__PURE__*/_defineComponent({
  __name: 'ControlCenterEditor',
  props: {
  data: Object
},
  setup(__props) {

const props = __props

const globalStore = useGlobalStore();
const { t } = useI18n();
const phoneNumbersValidator = helpers.regex(/^\+[0-9]+$/);



const popupData = toRef(props, 'data');

onMounted(async () => {
  globalStore.modal.validator = v$;
})


// Validation

const rules = computed(() => {
  const rules = {
    name: { required: helpers.withMessage(t('validators.required'), required) },
    phoneNumber: {
      required: helpers.withMessage(t('validators.required'), required),
      phoneNumbersValidator: helpers.withMessage(
          $t('validators.phoneNumber'),
          phoneNumbersValidator
      ),
    },
  }
  return rules
})

const v$ = ref(useVuelidate(rules, popupData))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('controlCenters.syncId')), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(Text), {
            modelValue: _unref(popupData).syncId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(popupData).syncId) = $event))
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('controlCenters.name')) + " * ", 1),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: _normalizeClass({ error: v$.value.name.$errors.length })
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(popupData).name) = $event)),
              class: "w-full"
            }, null, 512), [
              [_vModelText, _unref(popupData).name]
            ]),
            _hoisted_10,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.name.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: error.$uid
              }, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(error.$message), 1)
              ]))
            }), 128))
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('controlCenters.phoneNumber')) + " * ", 1),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", {
            class: _normalizeClass({ error: v$.value.phoneNumber.$errors.length })
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(popupData).phoneNumber) = $event)),
              class: "w-full",
              placeholder: _unref(phoneNumberPlaceholder)
            }, null, 8, _hoisted_15), [
              [_vModelText, _unref(popupData).phoneNumber]
            ]),
            _hoisted_16,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.phoneNumber.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: error.$uid
              }, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(error.$message), 1)
              ]))
            }), 128))
          ], 2)
        ])
      ])
    ])
  ]))
}
}

})